import styled from 'styled-components'

import { Sidebar as SidebarStyled } from 'ui/components/sidebar'

export const Wrapper = styled.main`
  display: flex;
  height: 100vh;
`

export const Sidebar = styled(SidebarStyled)``
